import React, { FunctionComponent, useMemo } from "react";

import { IPublicAttributeInfo } from "@multiweb/types/contracts";
import { RecordType } from "@multiweb/types/react";
import { defaultCanRenderEmpty, defaultCanRenderEncrypted } from "../../utils";
import { LiteListFrameGeneralAttributeProps } from "../LiteListFrameGeneralAttribute";
import { connectAttribute, LiteListFrameAttribute, withBackgroundAttr } from "./attribute";
import {
    connectPlaceholder,
    LiteListFrameEmptyAttributePlaceholder,
    LiteListFrameEncryptedAttributePlaceholder,
    LiteListFrameSkeletonAttributePlaceholder,
} from "./placeholders";
import { PlaceholderComponent } from "./types";

export type LiteListFrameGeneralAttributeComponentProps = LiteListFrameGeneralAttributeProps & {
    /** Záznam z modulu dataSource. */
    dataSourceAttributeInfo?: IPublicAttributeInfo;
    /** Obecné informace k danému atributu. */
    record?: RecordType;
};

export const LiteListFrameGeneralAttributeComponent: FunctionComponent<LiteListFrameGeneralAttributeComponentProps> = ({
    dataSourceKey,
    recordId,
    attributeName,
    canRenderEncrypted = defaultCanRenderEncrypted,
    canRenderEmpty = defaultCanRenderEmpty,
    dataSourceAttributeInfo,
    record,
    SkeletonPlaceholder = LiteListFrameSkeletonAttributePlaceholder,
    EncryptedPlaceholder = LiteListFrameEncryptedAttributePlaceholder,
    EmptyPlaceholder = LiteListFrameEmptyAttributePlaceholder,
    AttributeComponent = LiteListFrameAttribute,
    inline = false,
    hasBackgroundAttr = false,
    iconCode,
}) => {
    let PlaceholderComponent: PlaceholderComponent | undefined;
    if (!record || !dataSourceAttributeInfo) {
        PlaceholderComponent = SkeletonPlaceholder;
    } else if (canRenderEncrypted(record, dataSourceAttributeInfo)) {
        PlaceholderComponent = EncryptedPlaceholder;
    } else if (canRenderEmpty(record, dataSourceAttributeInfo)) {
        PlaceholderComponent = EmptyPlaceholder;
    }

    const result = useMemo(() => {
        if (PlaceholderComponent) {
            const Placeholder = connectPlaceholder(PlaceholderComponent);
            return <Placeholder {...{ dataSourceKey, recordId, attributeName }} />;
        } else {
            const Attribute = withBackgroundAttr(connectAttribute(AttributeComponent));
            return <Attribute {...{ dataSourceKey, recordId, attributeName, inline, hasBackgroundAttr, iconCode }} />;
        }
    },
    [PlaceholderComponent, AttributeComponent, attributeName, dataSourceKey, inline, recordId, hasBackgroundAttr, iconCode]);

    return result;
};
